<template>
	<div v-if="active" class="loader-wrapper">
		<div class="loader">
			<div class="spinner"></div>
		</div>
		<span>{{ text }}</span>
	</div>
</template>

<script>
export default {
	name: "SpinnerShow",
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		text: {
			type: String,
			default: "aaa",
		},
	},
}
</script>

<style scoped>
.loader-wrapper {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(94, 86, 86, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.loader {
	display: inline-block;
	position: relative;
	width: 80px;
	height: 80px;
}

/* スピナーのスタイルを変更 */
.spinner {
	width: 40px;
	height: 40px;
	border: 4px solid #F6A8B5;
	border-top: 4px solid #54ADC3;
	border-radius: 50%;
	animation: spin 1s linear infinite;
}

span {
	color: #F6A8B5;
}

/* 回転アニメーションの定義 */
@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>